/// <amd-module name="Widgets/SprintBurndownConfig/Pickers/IterationsPickerHelper" />
import { Iteration } from "Analytics/Boards/BoardsQueries/IterationsQuery";
import { IVssPageContext } from "VSS/Platform/Context";
import { IListBoxItem } from "VSSUI/ListBox";
import {
    getIterations,
    populateSymbolicCurrentIteration
} from "Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/ConfigQueries/IterationsHelper";

/** Gets a list of iterations scoped to the supplied team  */
export async function getIterationItems(pageContext: IVssPageContext, projectId: string, teamId: string): Promise<IListBoxItem<Iteration>[]> {
    const iterations = (await getIterations(pageContext, projectId, teamId)).slice(0);
    iterations.unshift(populateSymbolicCurrentIteration(iterations));
    const iterationItems = iterations.map(item => {
        const iteration: IListBoxItem<Iteration> = {
            data: item,
            id: item.IterationSK,
            text: item.IterationName
        };
        return iteration;
    });
    return iterationItems;
}

/** Ensures a default iteration is selected, with preference to an initially supplied iteration Id.
 *  Returns an empty iteration object if there is no valid iteration available.
 */
export function ensureIteration(iterations: IListBoxItem<Iteration>[], initialIterationId?: string): Iteration {
    let activeIteration: Iteration | undefined = undefined;
    if (initialIterationId) {
        const index = iterations.findIndex((item: IListBoxItem<Iteration>) => {
            return item.data!.IterationSK === initialIterationId;
        });
        if (index >= 0) {
            activeIteration = iterations[index].data!;
        }
    }

    if (activeIteration === undefined) {
        if (iterations.length > 0) {
            activeIteration = iterations[0].data!;
        } else {
            // An empty iteration object - Allows UI to continue functioning in circumstance of team with no iteration data.
            activeIteration = {
                IterationSK: "",
                IterationName: "",
                EndDateTimeOffset: "",
                StartDateTimeOffset: ""
            } as Iteration;
        }
    }
    return activeIteration;
}
